module.exports = {
      id: "vikatan-usage",
      viewBox: "0 0 30 30",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#vikatan",
      toString: function () {
        return this.url;
      }
    }